import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { keyframes } from '@mui/system';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Loading = ({ message = 'Loading...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        bgcolor: 'background.default',
        animation: `${fadeIn} 0.3s ease-out`,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'inline-flex',
          '&::after': {
            content: '""',
            position: 'absolute',
            top: -4,
            left: -4,
            right: -4,
            bottom: -4,
            borderRadius: '50%',
            background: 'linear-gradient(45deg, primary.main, primary.light)',
            opacity: 0.1,
            animation: 'pulse 2s ease-in-out infinite',
          },
          '@keyframes pulse': {
            '0%': {
              transform: 'scale(1)',
              opacity: 0.1,
            },
            '50%': {
              transform: 'scale(1.1)',
              opacity: 0.2,
            },
            '100%': {
              transform: 'scale(1)',
              opacity: 0.1,
            },
          },
        }}
      >
        <CircularProgress
          size={60}
          thickness={4}
          sx={{
            color: 'primary.main',
            animation: 'spin 1.5s linear infinite',
            '@keyframes spin': {
              '0%': {
                transform: 'rotate(0deg)',
              },
              '100%': {
                transform: 'rotate(360deg)',
              },
            },
          }}
        />
      </Box>
      <Typography
        variant="h6"
        sx={{
          mt: 3,
          color: 'text.primary',
          fontWeight: 500,
          letterSpacing: '0.5px',
          animation: `${fadeIn} 0.3s ease-out 0.1s both`,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default Loading;
